import {Meta} from "./meta";

export class Data {
    public data: any;
    public meta: Meta;
}